import {request} from '@/helpers/apiClient'
import {FILE_UPLOAD_CONFIG} from '@/utils/constants/apiConfig/fileUploadConfig'
import {Constants} from '@/utils/constants/commonConstants'

/**
 * Handles file verification uploads for different contexts
 *
 * @param {FormData} formData - The form data containing the file to upload
 * @param {string} [uploadFor] - The upload context
 * @param {Function} [onUploadProgress] - Progress callback function
 * @param {string} [type='csv'] - File type
 * @returns {Promise<any>} - API response
 */
export const getFileVerification = async (formData, uploadFor, onUploadProgress, type = 'csv') => {
  const uuid = crypto.randomUUID()
  const queryParams = `type=${type}&uuid=${uuid}`
  const options = {data: formData, onUploadProgress}

  switch (uploadFor) {
    case Constants.SalesTargetMedia:
      return request(FILE_UPLOAD_CONFIG.UPLOAD_SALES_TARGET_CONTENT, options, queryParams)

    case Constants.BulkModifiers:
      return request(FILE_UPLOAD_CONFIG.UPLOAD_BULK_MODIFIER_FILE, options, 'type=csv&uuid=' + uuid)

    case Constants.RewardsTierStoreUpload:
      return request(FILE_UPLOAD_CONFIG.REWARDS_TIER_STORE_UPLOAD, options, queryParams)

    case Constants.SalesTarget:
      return request(FILE_UPLOAD_CONFIG.UPLOAD_SALES_TARGET_MEDIA, options, 'uuid=' + uuid)

    case Constants.Media:
      return request(FILE_UPLOAD_CONFIG.UPLOAD_MEDIA, options, 'uuid=' + uuid)

    default:
      return request(FILE_UPLOAD_CONFIG.UPLOAD_SALES_TARGET_CONTENT, options, queryParams)
  }
}
